<ng-template [ngxPermissionsOnly]="['emailtemplates:can_get_emailtemplates_reports_sent']">
  <div class="box-row panel panel-default">
    <div class="panel-heading">
      <h4>Email Sent Trend</h4>
    </div>
    <div class="panel-body text-center">
      <div *ngIf="!isLoaded">
        <div class="whirl standard spinnermargin"></div>
      </div>
      <ng-template [ngIf]="isLoaded">
        <line-chart [chartData]="chartData"></line-chart>
      </ng-template>
    </div>
  </div>
</ng-template>
